
export const languageNameToCode = {
  'US English': 'en_us',
  'Australian English': 'en_au',
  'British English': 'en_uk',
  Spanish: 'es',
  French: 'fr',
  German: 'de',
  Italian: 'it',
  Portuguese: 'pt',
  Dutch: 'nl',
  Hindi: 'hi',
  Japanese: 'ja',
  Chinese: 'zh',
  Finnish: 'fi',
  Korean: 'ko',
  Polish: 'pl',
  Russian: 'ru',
  Turkish: 'tr',
  Ukrainian: 'uk',
  Vietnamese: 'vi',
}

export const withSpeakerLabels = [
  'English',
  'US English',
  'Australian English',
  'British English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Dutch',
  'Finish',
  'Polish',
  'Russian',
  'Turkish',
]

